import store from '@/core/common/services/vuex-store.js';
export default {
  inserted(el, binding, vnode) {
    const roles = store.getters.customRoles ? store.getters.customRoles : store.getters.parsedRoles;
    const currentUserId = store.getters.currentUser?.localAccountId;
    const getUsernameById = store.getters.getUsernameById;

    let authorize, authorizedUsers;
    if (Array.isArray(binding.value)) {
      authorize = binding.value;
      authorizedUsers = [];
    } else {
      authorize = binding.value.roles || [];
      authorizedUsers = binding.value.users || [];
    }

    let notAllowed = true;

    roles.forEach(value => {
      if (authorize.includes(value)) {
        notAllowed = false;
      }
    });

    if (authorizedUsers.includes(currentUserId)) {
      notAllowed = false;
    }

    if (notAllowed) {
      vnode.elm.parentElement.removeChild(vnode.elm);
    } else {
      // Marks all for others hidden elements with a yellow star #2045
      if (!store.state.userSettingsLocal.hideRoleIndicators && roles.includes('Admin')) {
        const insertElement = vnode.elm.firstChild instanceof Element ? vnode.elm.firstChild : vnode.elm;
        const titleText = `Nur sichtbar für: ${authorize.join(',')} ${
          authorizedUsers.length > 0
            ? ', ' + authorizedUsers.map(user => getUsernameById(user)).join(',')
            : ''
        }`;
        insertElement.insertAdjacentHTML(
          'beforeend',
          `<span class="text-warning" title="${titleText}">*</span>`
        );
      }
    }
  },
};
